import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineRetweet } from 'react-icons/ai'
import { firestore, auth } from '../../firebase/firebase-utils';
import './styles.scss'
import TextEditor from '../../Text-Editor'
import Spinner from '../../Text-Editor/Spinner'
import Code from '../../Text-Editor/code.prettier'
import {withRouter} from 'react-router-dom'

class answer extends Component {
    constructor() {
        super()

        this.state = {
            User: null,
            key: 'all',
            modalShow: false,
            answer: '',
            loader: false,
            code: null
        }
    }
    unSubscribeFromAuth = null;
    componentDidMount = () => {
        this.unSubscribeFromAuth = auth.onAuthStateChanged(user => {
            this.setState({ User: user })
        })
    }
    componentWillUnmount = () => {
        this.unSubscribeFromAuth = null;
    }
    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        });
    };

    postAnswer = () => {
        if (this.state.User) {
            this.setState({ loader: true })
            firestore.collection("answers").doc().set({
                discrp: this.state.answer,
                queryid: this.props.docid,
                username: this.state.User.displayName,
                useremail: this.state.User.email,
                userimage: this.state.User.photoURL,
                uid: this.state.User.uid,
                order: Date.now(),
                likes: [],
                saved: [],
                comments: [],
                code: this.state.code
            }).then(() => {
                this.setState({ loader: false })
                window.alert("Document written successfully")
                this.setState({ modalShow: false })
                this.props.history.push('/community/' + this.props.docid)
                if(this.props.reload){
                    window.location.reload();
                }
            }).catch((error) => {
                window.alert("Error: " + error)
            })
        }
    }

    DescripCall = (e) => {
        this.setState({ answer: e })
        console.log(this.state.answer)
    }

    CodeTextCall = (e) => {
        this.setState({ code: e })
    }

    render() {
        return (
            <div style={{ display: 'inline' }}>
                {this.state.loader ? <Spinner /> : null}
                <AiOutlineRetweet onClick={() => this.setState({ modalShow: true })} />{'  '}<span onClick={() => this.setState({ modalShow: true })} style={{ color: '#057BD0' }}>Answer</span>
                {/* modal  */}
                <Modal
                    size='lg'
                    aria-labelledby="contained-modal-title-vcenter"
                    centered show={this.state.modalShow} onHide={() => this.setState({ modalShow: false })}>
                    <Modal.Header>
                        <h4>Answer the query</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <TextEditor callFunction={this.DescripCall.bind(this)} collection="queries" />
                        <br />
                        <Code callFunction={this.CodeTextCall.bind(this)} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ modalShow: false })}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.postAnswer}>
                            send
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default withRouter(answer);